import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

export enum AdaptiveModuleModeEnum {
  LIST = 'list',
  GRID = 'grid',
}

@Component({
  standalone: false,
  selector: 'campus-adaptive-module',
  templateUrl: './adaptive-module.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdaptiveModuleComponent {
  modes: typeof AdaptiveModuleModeEnum = AdaptiveModuleModeEnum;

  @HostBinding('class')
  defaultClasses = ['block', 'stack', 'stack-space-3xl', 'overflow-visible'];

  @HostBinding('class.opacity-low')
  @HostBinding('class.filter')
  @HostBinding('class.grayscale-full')
  @HostBinding('class.pointer-event-none')
  @Input()
  disabled = false;

  @Input()
  showProgress = true;
}
